///<reference path="processEditor-module.ts"/>
///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="recursionHelper.ts"/>
module ProcessEditor {
    function getDirectiveForController(controllerName: string, templateUrl: string, RecursionHelper: RecursionHelper): ng.IDirective {
        return {
            restrict: "EA",
            templateUrl: templateUrl,
            controller: controllerName,
            controllerAs: "ctrl",
            bindToController: true,
            scope: {
                node: "=",
                process: "=" // needed by trigger modal editor
            },
            compile: function(element) {
                // Use the compile function from the RecursionHelper,
                // And return the linking function(s) which it returns
                return RecursionHelper.compile(element, null);
            }
        };
    }

    export function rootScopeEditorDirective(RecursionHelper: RecursionHelper): ng.IDirective {
        return getDirectiveForController("RootScopeEditorController", "rootScopeEditor.htm", RecursionHelper);
    }
    app.directive("frendsRootScopeEditor", ["RecursionHelper", rootScopeEditorDirective]);

    export function foreachScopeEditordirective(RecursionHelper: RecursionHelper): ng.IDirective {
        return getDirectiveForController("ForeachScopeEditorController", "foreachScopeEditor.htm", RecursionHelper);
    }
    app.directive("frendsForeachScopeEditor", ["RecursionHelper", foreachScopeEditordirective]);

    export function errorScopeEditordirective(RecursionHelper: RecursionHelper): ng.IDirective {
        return getDirectiveForController("ErrorScopeEditorController", "errorScopeEditor.htm", RecursionHelper);
    }
    app.directive("frendsErrorScopeEditor", ["RecursionHelper", errorScopeEditordirective]);

    export function scopeGraphDirective(): ng.IDirective {
        return {
            restrict: "A",
            templateUrl: "scopeGraph.htm"
        };
    }

    app.directive("frendsScopeGraph", [scopeGraphDirective]);

    export function scopeMenuDirective(): ng.IDirective {
        return {
            restrict: "A",
            templateUrl: "scopeMenu.htm"
        }
    }

    app.directive("frendsScopeMenu", [scopeMenuDirective]);

    /** Directive for setting the node execution state class so not executed elements are grayed out */
    export function setNodeExecutionStateClass($parse: ng.IParseService, highlightExecutions: boolean): ng.IDirective {
        return {
            restrict: "A",
            link: (scope, element, attrs) => {
                if(highlightExecutions){
                  var node = <INodeWithExecutionData>$parse(attrs["frendsSetNodeExecutionStateClass"])(scope);
                  if (node && node.executionData && node.executionData.state) {
                      element.addClass(`process-node-${node.executionData.state.toLowerCase() }`);
                  } else{
                      element.addClass("process-node-not-executed");
                  }
                }
            }
        }
    }
    app.directive("frendsSetNodeExecutionStateClass", ["$parse", "highlightExecutions", setNodeExecutionStateClass]);
}
